// helper functions used across both application and public pages

module.exports = {
  shouldContactSales(transfer) {
    const transferValue = Number(transfer.replace('gb', ''));

    // anything over 100 GB needs to contact sales
    return (transferValue >= 100);
  }
};
